module.exports = __webpack_public_path__ + "static/media/Courses.8513e587.png";